/*
  GuidesForYourLife product page
  - Adds a guide to the cart without leaving the page, then shows "Check out".
  - "Upgrade to the bundle": swaps this guide for the Mind Reset Bundle.
  - Guide finder (two-question quiz) and the bundle page's one-tap picker.
  - Bundle page and All guides page: adding the bundle takes single guides out of the cart,
    so nobody pays twice. Guide cards show "In cart" or "In your bundle".
  Everything still works without this file: the forms then go to the cart page.
*/
(function () {
  if (window.gfylProductLoaded) return;
  window.gfylProductLoaded = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function ids() {
    var el = document.querySelector('[data-gfyl-ids]');
    if (!el) return null;
    return {
      product: Number(el.getAttribute('data-product-id')) || 0,
      bundle: Number(el.getAttribute('data-bundle-id')) || 0
    };
  }

  function stateFromCart(cart) {
    var i = ids();
    var state = 'none';
    if (!i || !cart || !cart.items) return state;
    cart.items.forEach(function (item) {
      if (i.bundle && item.product_id === i.bundle) state = 'bundle';
      else if (item.product_id === i.product && state !== 'bundle') state = 'guide';
    });
    return state;
  }

  function setState(state) {
    document.querySelectorAll('[data-gfyl-show]').forEach(function (el) {
      var show = (el.getAttribute('data-gfyl-show') || '').split(' ');
      el.hidden = show.indexOf(state) === -1;
    });
    document.documentElement.setAttribute('data-gfyl-cart', state);
  }

  function updateCartIcons(count) {
    var links = document.querySelectorAll('a.gfyl-hdr__icon[href$="/cart"]');
    links.forEach(function (a) {
      var badge = a.querySelector('.gfyl-hdr__count');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'gfyl-hdr__count';
          badge.setAttribute('aria-hidden', 'true');
          a.appendChild(badge);
        }
        badge.textContent = String(count);
      } else if (badge) {
        badge.parentNode.removeChild(badge);
      }
      a.setAttribute('aria-label', count === 1 ? 'Cart, 1 item' : count > 1 ? 'Cart, ' + count + ' items' : 'Cart');
    });
  }

  function getCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });
  }

  function post(path, body) {
    return fetch(root + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error(path + ' ' + r.status);
      return r.json();
    });
  }

  // The single guides on this page that the bundle replaces (bundle page, All guides page, guide pages).
  function swapInfo() {
    var el = document.querySelector('[data-gfyl-guide-ids]');
    if (!el) return null;
    var list = (el.getAttribute('data-gfyl-guide-ids') || '').split(',').map(Number).filter(Boolean);
    return { variant: Number(el.getAttribute('data-bundle-variant')) || 0, ids: list };
  }

  // Before adding the bundle, take any single guides out of the cart. Resolves with how many were removed.
  function clearGuides(variantId, alsoVariant) {
    var info = swapInfo();
    var wantsBundle = info && info.variant && variantId === info.variant;
    if (!wantsBundle && !alsoVariant) return Promise.resolve(0);
    return getCart().then(function (cart) {
      var updates = {};
      var n = 0;
      (cart.items || []).forEach(function (item) {
        var isGuide = wantsBundle && info.ids.indexOf(item.product_id) !== -1;
        if (isGuide || (alsoVariant && item.variant_id === alsoVariant)) { updates[item.key] = 0; n++; }
      });
      if (!n) return 0;
      return post('cart/update.js', { updates: updates }).then(function () { return n; });
    });
  }

  function syncExtras(cart) {
    var items = (cart && cart.items) || [];
    var i = ids();
    var hasBundle = !!(i && i.bundle && items.some(function (it) { return it.product_id === i.bundle; }));
    document.querySelectorAll('[data-gfyl-card]').forEach(function (card) {
      var pid = Number(card.getAttribute('data-product-id'));
      var st = hasBundle ? 'bundle' : (items.some(function (it) { return it.product_id === pid; }) ? 'added' : 'none');
      card.querySelectorAll('[data-gfyl-card-show]').forEach(function (el) {
        el.hidden = (el.getAttribute('data-gfyl-card-show') || '').split(' ').indexOf(st) === -1;
      });
    });
    var info = swapInfo();
    var hasSingles = !!(info && items.some(function (it) { return info.ids.indexOf(it.product_id) !== -1; }));
    document.querySelectorAll('[data-gfyl-swap-note]').forEach(function (el) { el.hidden = hasBundle || !hasSingles; });
  }

  function showSwapped(n) {
    document.querySelectorAll('[data-gfyl-swapped]').forEach(function (el) { el.hidden = !n; });
  }

  function refresh() {
    return getCart().then(function (cart) {
      setState(stateFromCart(cart));
      updateCartIcons(cart.item_count || 0);
      syncExtras(cart);
      return cart;
    });
  }

  function busy(btn, on) {
    if (!btn) return;
    btn.disabled = on;
    btn.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  function announce(message) {
    var live = document.getElementById('gfyl-live');
    if (!live || !message) return;
    live.textContent = '';
    window.setTimeout(function () { live.textContent = message; }, 60);
  }

  // After a button disappears, put keyboard focus somewhere sensible in the same section.
  function refocus(from) {
    var active = document.activeElement;
    if (active && active !== document.body && active.offsetParent !== null) return;
    var card = from && from.closest('[data-gfyl-card]');
    if (card) {
      var inCard = card.querySelector('a[data-gfyl-card-show]:not([hidden]), [data-gfyl-card-show]:not([hidden]) a, [data-gfyl-card-show]:not([hidden]) button');
      if (inCard) { inCard.focus({ preventScroll: true }); return; }
    }
    var scope = (from && from.closest('.shopify-section')) || document;
    var target = scope.querySelector('[data-gfyl-focus]:not([hidden]) [tabindex="-1"], a[data-gfyl-show]:not([hidden]), [data-gfyl-show]:not([hidden]) a, [data-gfyl-show]:not([hidden]) button');
    if (target) target.focus({ preventScroll: true });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    // Add this guide
    if (form.hasAttribute('data-gfyl-add')) {
      if (!window.fetch) return;
      event.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var idInput = form.querySelector('[name="id"]');
      var vid = Number(idInput.value);
      var removed = 0;
      busy(btn, true);
      clearGuides(vid)
        .then(function (n) { removed = n; return post('cart/add.js', { items: [{ id: vid, quantity: 1 }] }); })
        .then(refresh)
        .then(function () {
          busy(btn, false);
          showSwapped(removed);
          announce(form.getAttribute('data-gfyl-added') || 'Added to your cart');
          refocus(form);
        })
        .catch(function () {
          busy(btn, false);
          HTMLFormElement.prototype.submit.call(form);
        });
      return;
    }

    // Swap to the bundle (removes this guide first, if it's in the cart)
    if (form.hasAttribute('data-gfyl-bundle')) {
      if (!window.fetch) return;
      event.preventDefault();
      var btn2 = form.querySelector('[type="submit"]');
      var bundleVariant = Number(form.getAttribute('data-variant'));
      var removeVariant = Number(form.getAttribute('data-remove')) || 0;
      var removed2 = 0;
      busy(btn2, true);
      clearGuides(bundleVariant, removeVariant)
        .then(function (n) { removed2 = n; return post('cart/add.js', { items: [{ id: bundleVariant, quantity: 1 }] }); })
        .then(refresh)
        .then(function () {
          busy(btn2, false);
          showSwapped(removed2);
          announce(form.getAttribute('data-gfyl-added') || 'Mind Reset Bundle added to your cart');
          refocus(form);
        })
        .catch(function () {
          busy(btn2, false);
          window.location.href = form.getAttribute('action');
        });
    }
  });

  // ---------------- Guide finder ----------------
  function renderFinder(finder, fromReset) {
    var q1 = finder.getAttribute('data-q1');
    var q2 = finder.getAttribute('data-q2');
    finder.querySelectorAll('[data-gfyl-q1]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-gfyl-q1') === q1 ? 'true' : 'false');
    });
    finder.querySelectorAll('[data-gfyl-q2]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-gfyl-q2') === q2 ? 'true' : 'false');
    });
    var step2 = finder.querySelector('[data-gfyl-step2]');
    if (step2) step2.hidden = !q1;
    var shown = null;
    finder.querySelectorAll('[data-gfyl-result]').forEach(function (panel) {
      var on = !!(q1 && q2) && panel.getAttribute('data-gfyl-result') === q2 + '-' + q1;
      panel.hidden = !on;
      if (on) shown = panel;
    });
    var results = finder.querySelector('[data-gfyl-results]');
    if (results) results.hidden = !shown;
    if (fromReset) {
      var first = finder.querySelector('[data-gfyl-q1]');
      if (first) first.focus();
    }
  }

  document.addEventListener('click', function (event) {
    var b = event.target.closest('[data-gfyl-q1], [data-gfyl-q2], [data-gfyl-reset]');
    if (!b) return;
    var finder = b.closest('[data-gfyl-finder]');
    if (!finder) return;
    if (b.hasAttribute('data-gfyl-q1')) finder.setAttribute('data-q1', b.getAttribute('data-gfyl-q1'));
    else if (b.hasAttribute('data-gfyl-q2')) finder.setAttribute('data-q2', b.getAttribute('data-gfyl-q2'));
    else {
      finder.removeAttribute('data-q1');
      finder.removeAttribute('data-q2');
      if (finder.hasAttribute('data-q2-fixed')) finder.setAttribute('data-q2', finder.getAttribute('data-q2-fixed'));
    }
    renderFinder(finder, b.hasAttribute('data-gfyl-reset'));
  });

  // ---------------- First-order offer ----------------
  // After someone joins, save the code for checkout so they don't have to type it.
  function applyOffer(box) {
    var code = box.getAttribute('data-code');
    var status = box.querySelector('[data-gfyl-offer-status]');
    var link = box.querySelector('[data-gfyl-offer-apply]');
    if (!code || !window.fetch) return;
    fetch(root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + 'cart.js'), { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) return;
        if (status && status.getAttribute('data-applied')) status.textContent = status.getAttribute('data-applied');
        if (link) link.hidden = true;
      })
      .catch(function () {});
  }

  function copyText(btn, text) {
    function done() {
      var old = btn.getAttribute('data-label') || btn.textContent;
      btn.setAttribute('data-label', old);
      btn.textContent = 'Copied';
      window.setTimeout(function () { btn.textContent = old; }, 1800);
      announce('Code copied');
    }
    function selectCode() {
      var box = btn.closest('[data-gfyl-offer-done]');
      var value = box && box.querySelector('.gfyl-code__value');
      if (!value || !window.getSelection) return;
      var range = document.createRange();
      range.selectNodeContents(value);
      var sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
    }
    try {
      navigator.clipboard.writeText(text).then(done, selectCode);
    } catch (e) { selectCode(); }
  }

  document.addEventListener('click', function (event) {
    var copy = event.target.closest('[data-gfyl-copy]');
    if (copy) { copyText(copy, copy.getAttribute('data-gfyl-copy')); return; }

    var apply = event.target.closest('[data-gfyl-offer-apply]');
    if (apply && window.fetch) {
      event.preventDefault();
      var box = apply.closest('[data-gfyl-offer-done]');
      fetch(apply.getAttribute('href'), { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('discount');
          var status = box && box.querySelector('[data-gfyl-offer-status]');
          if (status && status.getAttribute('data-applied')) status.textContent = status.getAttribute('data-applied');
          apply.hidden = true;
        })
        .catch(function () { window.location.href = apply.getAttribute('href'); });
      return;
    }

    var opener = event.target.closest('[data-gfyl-open-offer]');
    if (opener) {
      var target = document.getElementById('gfyl-offer');
      if (!target) return;
      event.preventDefault();
      target.open = true;
      target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      var input = target.querySelector('input[type="email"]');
      if (input) window.setTimeout(function () { input.focus({ preventScroll: true }); }, 350);
    }
  });

  function initOffers() {
    document.querySelectorAll('[data-gfyl-offer-done]').forEach(applyOffer);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initOffers);
  else initOffers();

  // Keep buttons right if the page came from the back/forward cache or the cart changed elsewhere.
  function sync() { if (ids()) refresh().catch(function () {}); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
  window.addEventListener('pageshow', function (e) { if (e.persisted) sync(); });
})();
